module.exports = __webpack_public_path__ + "media/images/svgs/jobs/buy-5a9278c4c0b1d9525bcb7ce91740bee0.svg";